import { useNavigate } from 'react-router-dom';
import './back.less';
import { ArrowBack } from '@mui/icons-material';

const Screenback = (props) => {
  const navigate = useNavigate();
  const whereTo = props.whereTo ? props.whereTo : -1;
  return (
    <div
      className={'backArrow'}
      style={{ display: 'flex', justifyContent: 'flex-start' }}
      onClick={() => {
        navigate(whereTo);
        if (props.onClick) {
          props.onClick();
        }
      }}
    >
      <ArrowBack/>
    </div>
  );
};

export default Screenback;
